




































import { Component, Vue } from "vue-property-decorator";

@Component
class DepositTypeSelect extends Vue {
  id = "";

  sheet = false;

  show(id) {
    this.id = id;
    this.sheet = true;
  }

  handleSendToContact() {
    this.$common.utils.helper.toFusionPath(this, "wallet", {
      name: "withdraw-contact",
      params: { id: this.id }
    });
  }

  handleSendToAddress() {
    this.$common.utils.helper.toFusionPath(this, "wallet", {
      name: "addresses-id",
      params: { id: this.id }
    });
  }
}
export default DepositTypeSelect;
